'use client'

import type { UseFormReturn } from 'react-hook-form'
import { Controller } from 'react-hook-form'
import OtpInput from 'react-otp-input'
import { Alert, Box, Button, Stack, Typography } from '@mui/material'

import { OtpFormData } from '../model/reportLostDeviceForm'

type OtpStepProps = {
  form: UseFormReturn<OtpFormData>
  email: string
  onSubmit: React.FormEventHandler<HTMLFormElement>
  onResend: () => void
  error: string | null
}

export function OtpStep({ form, email, onSubmit, onResend, error }: OtpStepProps) {
  const submitting = form.formState.isSubmitting
  const otp = form.watch('otp')

  return (
    <form onSubmit={onSubmit} noValidate>
      <Stack spacing={2}>
        <Typography variant="body2">
          Si un compte existe pour <strong>{email}</strong>, un code à 6 chiffres vient d'y être envoyé. Saisissez-le ci-dessous pour confirmer la
          désactivation.
        </Typography>
        <Box display="flex" justifyContent="center">
          <Controller
            name="otp"
            control={form.control}
            render={({ field }) => (
              <OtpInput
                value={field.value}
                onChange={field.onChange}
                numInputs={6}
                inputType="tel"
                shouldAutoFocus
                renderInput={(props) => (
                  <input
                    {...props}
                    style={{
                      width: 40,
                      height: 48,
                      margin: '0 4px',
                      fontSize: 22,
                      textAlign: 'center',
                      border: '1px solid rgba(0,0,0,0.23)',
                      borderRadius: 6,
                    }}
                  />
                )}
              />
            )}
          />
        </Box>
        {error && <Alert severity="error">{error}</Alert>}
        <Stack direction="row" spacing={1} justifyContent="space-between">
          <Button onClick={onResend} disabled={submitting}>
            Renvoyer le code
          </Button>
          <Button type="submit" variant="contained" color="error" disabled={submitting || otp.length !== 6}>
            Désactiver l'accès
          </Button>
        </Stack>
      </Stack>
    </form>
  )
}
